<template>
  <v-card
      v-if="permissao('dashboard_ranking_campanha_venda_margem_gerente')"
      outlined
      style="background: linear-gradient(135deg, #0B5C73 0%, #074464 100%); border-radius: 12px;"
      dark
  >
    <v-card-title>
      <v-icon color="white" class="mr-2" size="28">mdi-cash-multiple</v-icon>
      <div>
        <div class="text-h6 font-weight-bold">Campanha de Vendas 2ª Edição</div>
        <div class="text-caption d-none d-sm-block" style="opacity: 0.85;">2º Semestre 2026 · Sua filial</div>
      </div>
      <v-spacer />
      <v-img class="d-none d-md-flex" max-width="220" src="../../assets/icons/logo_min.png" />
    </v-card-title>

    <template v-if="!carregando">
      <v-tabs
          v-model="abaCampanhaVendaMargemGerente"
          background-color="transparent"
          show-arrows
          height="48px"
          slider-color="white"
          slider-size="3"
          color="white"
          class="elevation-0"
          dark
      >
        <v-tab
            v-for="mes in meses"
            :key="mes.mes"
            :tab-value="mes.mes"
            class="font-weight-medium text-capitalize"
        >
          <v-icon left size="20" class="mr-2">mdi-calendar-month</v-icon>
          <span>{{ mes.mes_formatado }}</span>
        </v-tab>
        <v-tab key="acumulado" tab-value="acumulado" class="font-weight-medium text-capitalize">
          <v-icon left size="20" class="mr-2">mdi-chart-box-outline</v-icon>
          <span>Acumulado Geral</span>
        </v-tab>
      </v-tabs>

      <v-divider class="white" />

      <v-card-text class="black--text pa-3">
        <v-tabs-items v-model="abaCampanhaVendaMargemGerente">
          <v-tab-item v-for="mes in meses" :key="mes.mes" :value="mes.mes">
            <campanha-venda-margem-gerente-tabela :lista="mes.lista" :mostrar-valores-financeiros.sync="mostrarValoresFinanceiros" />
          </v-tab-item>
          <v-tab-item key="acumulado" value="acumulado">
            <campanha-venda-margem-gerente-tabela :lista="acumulado" :mostrar-valores-financeiros.sync="mostrarValoresFinanceiros" acumulado />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </template>
    <v-card-text v-else class="text-center py-8">
      <v-progress-circular indeterminate color="white" size="48" width="4" />
      <div class="mt-4 white--text">Carregando classificação da campanha...</div>
    </v-card-text>
  </v-card>
</template>

<script>
// Card "Campanha de Vendas 2ª Edição" da visão gerente (DashboardRankingVendas.vue) — mesmas abas da visão
// de diretoria (CampanhaVendaMargem.vue: por mês + Acumulado Geral), mas como v-card inline em vez de
// dialog e com tabela plana (sem agrupar/expandir por classificação), no mesmo padrão do card "Educa
// Comercial Ivaiporã" (ver CampanhaVendaMargemGerenteTabela.vue). Sem a aba "Resultado Sorteio" (não faz
// sentido pra visão gerente). Os dois endpoints (.../gerente/meses/listar e .../gerente/acumulado/listar)
// já restringem o resultado à filial de quem chamou no backend — meta/venda (R$) vêm inclusos (visão
// gerencial, diferente da tela do próprio vendedor), mas ocultos por padrão na tabela, só aparecendo com o
// botão de olho no cabeçalho "% Atingimento" (ver mostrarValoresFinanceiros abaixo, compartilhado entre
// todas as abas via .sync).
import { mapState } from 'vuex';
import axios from 'axios';
import CampanhaVendaMargemGerenteTabela from './CampanhaVendaMargemGerenteTabela.vue';

export default {
  name: 'CampanhaVendaMargemGerente',
  components: { CampanhaVendaMargemGerenteTabela },
  data() {
    return {
      abaCampanhaVendaMargemGerente: null,
      // oculto por padrão — diferente da visão de diretoria (CampanhaVendaMargem.vue), que abre com essas
      // colunas visíveis; aqui é o gerente quem decide se quer ver meta/venda/margem, clicando no olho
      mostrarValoresFinanceiros: false,
      meses: [],
      acumulado: [],
      carregandoMeses: false,
      carregandoAcumulado: false,
    };
  },
  computed: {
    ...mapState(['backendUrl']),
    carregando() {
      return this.carregandoMeses || this.carregandoAcumulado;
    },
  },
  created() {
    if (this.permissao('dashboard_ranking_campanha_venda_margem_gerente')) {
      this.carregar();
    }
  },
  methods: {
    carregar() {
      this.carregandoMeses = true;
      axios
          .post(`${this.backendUrl}bonificacao/campanha-venda-margem/gerente/meses/listar`, {})
          .then((res) => {
            this.meses = res.data || [];
            // mesma escolha de aba padrão da visão de diretoria: o mês mais recente, não o acumulado —
            // é o que costuma interessar primeiro (o que está acontecendo agora)
            if (this.meses.length && !this.abaCampanhaVendaMargemGerente) {
              this.abaCampanhaVendaMargemGerente = this.meses[this.meses.length - 1].mes;
            }
          })
          .catch(() => {
            this.meses = [];
          })
          .finally(() => {
            this.carregandoMeses = false;
          });

      this.carregandoAcumulado = true;
      axios
          .post(`${this.backendUrl}bonificacao/campanha-venda-margem/gerente/acumulado/listar`, {})
          .then((res) => {
            this.acumulado = res.data || [];
          })
          .catch(() => {
            this.acumulado = [];
          })
          .finally(() => {
            this.carregandoAcumulado = false;
          });
    },
  },
};
</script>
